import { render, staticRenderFns } from "./OrderCompleteBoleto.vue?vue&type=template&id=fdfdb896&scoped=true"
import script from "./OrderCompleteBoleto.vue?vue&type=script&lang=js"
export * from "./OrderCompleteBoleto.vue?vue&type=script&lang=js"
import style0 from "./OrderCompleteBoleto.vue?vue&type=style&index=0&id=fdfdb896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfdb896",
  null
  
)

export default component.exports